"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M3.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM17.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM10.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"];
//# sourceMappingURL=more.js.map